// ===== CORE =====
/**
 * Perfis que um contato pode ter. Multiplo de proposito: uma mesma pessoa pode
 * ser lideranca comunitaria e comerciante, e obrigar a escolher um so faria a
 * base perder a informacao mais util para segmentar.
 *
 * A lista vive aqui, e nao no frontend, porque a API valida contra ela -- foi
 * a divergencia entre duas listas paralelas que produziu o achado 4.2 da
 * auditoria.
 */
export const PERFIS_CONTATO = [
    'Cidadão(ã)',
    'Liderança comunitária',
    'Liderança religiosa',
    'Ex-vereador(a)',
    'Ex-prefeito(a)',
    'Ex-deputado(a)',
    'Servidor(a) público(a)',
    'Empresário(a)',
    'Sindicalista',
    'Imprensa',
    'Agente de saúde',
    'Professor(a)',
    'Estudante',
    'Associação / ONG',
];
//# sourceMappingURL=index.js.map